import { call, put, takeEvery } from "redux-saga/effects";

import {
  getMaintenanceStart,
  getMaintenanceSuccess,
  getMaintenanceFailure
} from "../../redux/settings/";
import Maintenance from "../../../services/maintenance";
// import { showErrorMessage } from "../../redux/toast";

function* settingsWatcher() {
  yield takeEvery(getMaintenanceStart.type, settingsWorker);
}

function* settingsWorker() {
  try {
    const { data, error } = yield call(Maintenance.getMaintenanceStatus);

    if (!error) {
      yield put(getMaintenanceSuccess(data));
    }
    if (error) {
      // yield put(showErrorMessage({ msg: error.message }));
      yield put(getMaintenanceFailure());
    }
  } catch (error) {
    // yield put(showErrorMessage({ msg: error.message }));
    yield put(getMaintenanceFailure());
  }
}

export default settingsWatcher;
